module.exports = __webpack_public_path__ + "img/stretch--genre3-img2.ba9d747a.jpg";